/**************************************************************************
 * Created on Mon Nov 04 2024
 *
 *  # Honeywell Code Usage Policy
 *
 * **Honeywell Source Code Usage Policy Classification:** Highly Confidential
 *
 * [comment]: # (Options for above are "Inner Source", "General Application", "Highly Confidential", "Export Controlled")
 *
 * **This repository has multiple classifications:** Yes
 *
 * [comment]: # (Options for above are "Yes" when subfolders contain a separate policy,"No" when the whole repo has the same policy)
 *
 * **Honeywell confidential - For internal use only.
 *
 * Property of and copyright ownership by Honeywell International Inc. and/or its affiliates.
 *
 * Use of source code must follow all Honeywell policies including the [HCE Source Code Access Policy](http: //go.honeywell.com/hce-code-access-policy).
 *
 * External use or distribution prohibited without written approval per Honeywell policies**
 *
********************************************************************************/

import { createContext, useContext } from "react";
import { IPropsGeneralModal } from "../model/model";

export const ModalContext = createContext<IPropsGeneralModal | undefined>(undefined);

/***
 * Modal Provider need to be wrapped the current component or it's parent level to active the modal window 
 * Prefferbly use it at Router level
 * 
 * @example
   <ModalProvider>
                <Routes>
                    <></>
                </Routes>              
    </ModalProvider>  

            **OR**

     <ModalProvider>
                </MyComponent >          
    </ModalProvider>  

    Use like below in Component

    const { openConfirmModal,openAlertmModal,closeConfirmModal } = useModal();
 */
export const useModal = () =>
{
    const c = useContext(ModalContext);
    if (!c)
    {
        throw new Error('useModal Must be use in ModalProvider')
    }
    return c
} 